module.exports = __webpack_public_path__ + "static/img/logo_zurquijpg.f2eddc27.jpg";